import HTTP from "@/_helpers/http";
import { PLATFORMS__API } from "@/_helpers/urls";
import { PLATFORMS__MUTATIONS } from "../mutation-types";
import { PLATFORMS__ACTIONS } from "../action-types";

// State
const state = {
    platforms: [],
};

//Getters
const getters = {};

//Mutations
const mutations = {
    [PLATFORMS__MUTATIONS.DOWNLOADPLATFORMS](state, data) {
        state.platforms = data.downloadPlatforms;
    },
};
// Actions
const actions = {
    async [PLATFORMS__ACTIONS.DOWNLOADPLATFORMS]({ commit, state }) {
        try {
            const url = `${PLATFORMS__API.DOWNLOADPLATFORMS}`;
            const response = await HTTP({
                trackProgress: true,
                loadingText: 'Processing...'
            }).get(url);
            commit(PLATFORMS__MUTATIONS.DOWNLOADPLATFORMS, response.data);
        } catch (error) {
            console.log(error);
        }
    },
};

export default {
    namespaced: true,
    strict: process.env.NODE_ENV !== "production",
    state,
    getters,
    mutations,
    actions,
};
